<script setup lang="ts">
  import { computed } from 'vue';
  import type { MatrixCodeRevision } from '@/entities/Matrix';
  import { DocumentRevisionStatusLabels, getDocumentRevisionStatusClasses } from '@/shared/lib';
  import RecordTypeBadge from './RecordTypeBadge.vue';

  const props = defineProps<{
    row: MatrixCodeRevision;
  }>();

  const title = computed(() => props.row.title ?? '-');

  const revisionNumber = computed(() => String(props.row.revision).padStart(2, '0'));

  const badgeLabel = computed(() => DocumentRevisionStatusLabels[props.row.status]);

  const badgeClass = computed(() => getDocumentRevisionStatusClasses(props.row.status));
</script>

<template>
  <tr
    class="table-row-hover border-t border-gray-02 transition-colors duration-300 ease-out"
    :data-testid="`matrix-revision-row-${props.row.id}`"
  >
    <td class="py-3 pl-6 text-left align-middle text-sm whitespace-nowrap text-gray-07">
      <div class="flex min-w-0 items-center gap-2">
        <RecordTypeBadge :record-type-name="props.row.recordTypeName" />
        <span
          class="min-w-0 truncate"
          data-testid="matrix-revision-code"
        >
          {{ props.row.code }}
        </span>
      </div>
    </td>
    <td class="py-3 pl-6 text-left align-middle text-sm text-gray-07">
      <div
        class="truncate"
        :title="props.row.title ?? undefined"
        data-testid="matrix-revision-title"
      >
        {{ title }}
      </div>
    </td>
    <td class="py-3 pl-6 text-left align-middle text-sm whitespace-nowrap text-gray-07">
      {{ revisionNumber }}
    </td>
    <td class="py-3 pl-6 text-left align-middle text-sm text-gray-07">
      <div class="flex w-19 items-center">
        <span
          :class="badgeClass"
          class="text-center"
          data-testid="matrix-revision-status-badge"
        >
          {{ badgeLabel }}
        </span>
      </div>
    </td>
    <slot
      name="actions"
      :row="props.row"
    />
  </tr>
</template>
